export const TEMPLATE_GENERATE_REQUEST = 'TEMPLATE_GENERATE_REQUEST';
export const TEMPLATE_GENERATE_POLLING = 'TEMPLATE_GENERATE_POLLING';
export const TEMPLATE_GENERATE_SUCCESS = 'TEMPLATE_GENERATE_SUCCESS';
export const TEMPLATE_GENERATE_FAILURE = 'TEMPLATE_GENERATE_FAILURE';
